import { memo } from 'react';
import { List, ListItem } from '@chakra-ui/react';
import ProjectCard from 'components/widgets/ProjectCard';
import { PaginatedProject } from 'types';
import { ViewProjectDetailsClickLocations } from 'utils/analytics/constants';

const projectCardListStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 'padding_8',
  overflow: 'auto',
};

const ProjectList = ({
  projectList,
  isPolygonSelected,
}: {
  projectList: PaginatedProject[];
  isPolygonSelected?: boolean;
}) => {
  return (
    <List sx={projectCardListStyle} aria-label="List of search results">
      {projectList.map((project) => {
        return (
          <ListItem key={`project-list-item-${project?.slug}`}>
            <ProjectCard
              project={project}
              clickLocation={ViewProjectDetailsClickLocations.LIST}
              isSecondaryItem={isPolygonSelected}
            />
          </ListItem>
        );
      })}
    </List>
  );
};

export default memo(ProjectList);
